import { fontConstants } from '../constants';
import { fontService } from '../services';

export const fontActions = {
  fetchFontDetails,
  updateFontDetailsFromSocket
};

function fetchFontDetails(forceRefresh = false) {
  return dispatch => {
    dispatch(request());

    fontService.fetchFontDetails(forceRefresh)
      .then(
        response => {
          const fontdetails = response?.data ?? response;
          dispatch(success(fontdetails != null ? fontdetails : []));
        },
        error => {
          dispatch(failure(error));
          // showToast(error.toString(), 'error');
        }
      );
  };

  function request() { return { type: fontConstants.FETCH_FONTDETAILS_REQUEST } }
  function success(fontdetails) { return { type: fontConstants.FETCH_FONTDETAILS_SUCCESS, fontdetails } }
  function failure(error) { return { type: fontConstants.FETCH_FONTDETAILS_FAILURE, error } }
}

function updateFontDetailsFromSocket(fontdetails) {
  return dispatch => {
    fontService.invalidateFontDetailsCache();

    dispatch({
      type: fontConstants.UPDATE_FONTDETAILS_FROM_SOCKET,
      fontdetails: fontdetails != null ? fontdetails : []
    });
  };
}
